import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useCreate from '../useCreate'
import toast from 'react-hot-toast'

const useCreateCategory = ({
    reset
}) => {
    const { categoryId } = useParams()
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { setDataToServer } = useCreate({
        url: 'category/create_update',
        refreshUrl: 'category/list',
        onSuccess: () => {
            // handleResetForm()
            // Always navigate to list after add or edit
            navigate(`/catalog/category`);
            toast.success("Category Added Successfully", {
                position: "top-right",
                duration: 3000
            })
        }
    })
    const handleSubmit = (data) => {
        let finalFormData
        if (categoryId) {
            finalFormData = {
                ...data,
                category_id: categoryId
            }
        } else {
            finalFormData = data
        }
        setDataToServer.mutate(finalFormData)
    }

    return { handleSubmit }
}

export default useCreateCategory